/* file description */
import { useEffect, useState } from 'react';
import { UseGetLabelByEdit } from './type';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import { COLUMN_FROM } from '../../../effects/consts';

export const useGetLabelByEdit: UseGetLabelByEdit = ({ value, field, form, config, columnFrom, setInputLabel, API, setExistVal, setSelectedRowKeys }) => {
  const { dataKey, treeId, value: filterField } = field?.options || {};
  const [renderData, setRenderData] = useState<any[]>([]);

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  const getShowFieldLabel = async (showNamespace: string, showModule: string, showModuleValue: string, showModuleLabel: string, initVal: string) => {
    const res = await getModuleRecordListCache(
      API.FetchAPI,
      showNamespace || 'master_data',
      showModule,
      {
        moduleID: showModule,
        namespaceID: showNamespace || 'master_data',
        limit: 100,
        filter: `${showModuleValue} = '${initVal}'`,
      },
    );
    const recordValues = res.set?.[0]?.values || [];
    const resultLabel = recordValues.find((json: any) => json.name === showModuleLabel)?.value || initVal;
    return resultLabel;
  };

  useEffect(() => {
    if (value) {
      const params: Record<any, any> = {
        moduleID: dataKey,
        namespaceID: treeId,
        filter: `${filterField} in ('${value}')`,
      };
      getModuleRecordListCache(API?.FetchAPI, treeId, dataKey, params).then((res: any) => {
        const { set = [] } = res || {};
        if (set.length === 0) {
          setExistVal(false);
          setSelectedRowKeys([]);
        } else {
          setExistVal(true);
          setSelectedRowKeys([set?.[0]?.recordID]);
        }
        const listData = set.map((r: any) => convert(r));
        setRenderData(listData);
      });
    } else {
      setSelectedRowKeys([]);
      setRenderData([]);
    }
  }, [value]);

  useEffect(() => {
    const { showFields = [] } = field.options || {};
    if (value) {
      const findDictItem = renderData?.find((item: Record<any, any>) => item[field?.options?.value] === value) || {};
      // 初始化回显值
      setInputLabel(field, findDictItem[field?.options?.label], value);
      // 初始化联动展示值
      showFields.forEach((item: { key: any; realLabel: any; showModule: any; showModuleLabel: any; showModuleValue?: string }) => {
        const values: Record<any, any> = {};
        const setName = `${field.name}_LINK_${item?.key}`;
        if (columnFrom === COLUMN_FROM.FORM) {
          if (item?.showModule && item?.showModuleLabel && item?.showModuleValue) {
            if (findDictItem[item?.key]) {
              getShowFieldLabel(item?.showNamespace, item?.showModule, item?.showModuleValue, item?.showModuleLabel, findDictItem[item?.key]).then((res: string) => {
                values[setName] = res;
                form.setFieldsValue(values);
              });
            }
          } else {
            values[setName] = findDictItem[item?.key];
            form.setFieldsValue(values);
          }
        }
        if (columnFrom === COLUMN_FROM.TABLE) {
          const tableKey = config.rowIndex;
          values[tableKey] = {};
          if (item?.showModule && item?.showModuleLabel && item?.showModuleValue) {
            if (findDictItem[item?.key]) {
              getShowFieldLabel(item?.showNamespace, item?.showModule, item?.showModuleValue, item?.showModuleLabel, findDictItem[item?.key]).then((res: string) => {
                values[tableKey][setName] = res;
                form.setFieldsValue(values);
              });
            }
          } else {
            values[tableKey][setName] = findDictItem[item?.key];
            form.setFieldsValue(values);
          }
        }
      });
    } else {
      showFields.forEach((item: { key: any; realLabel: any }) => {
        const values: Record<any, any> = {};
        const setName = `${field.name}_LINK_${item?.key}`;
        if (columnFrom === COLUMN_FROM.FORM) {
          values[setName] = '';
          form.setFieldsValue(values);
        }
        if (columnFrom === COLUMN_FROM.TABLE) {
          const tableKey = config.rowIndex;
          values[tableKey] = {};
          values[tableKey][setName] = '';
          form.setFieldsValue(values);
        }
      });
    }
  }, [renderData]);
};
